"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendAttributeValue = void 0;
const index_js_1 = require("../../../schema/actions/parse/index.js");
const appendAttributeValue = (conditionParser, attribute, expressionAttributeValue, options = {}) => {
    const { transform = false } = options;
    const parsed = new index_js_1.Parser(attribute).parse(expressionAttributeValue, {
        fill: false,
        transform
    });
    const expressionAttributeValueIndex = conditionParser.expressionAttributeValues.push(parsed);
    conditionParser.appendToExpression(`:${conditionParser.expressionAttributePrefix}${expressionAttributeValueIndex}`);
};
exports.appendAttributeValue = appendAttributeValue;
